export const CHARACTER_LIMIT_COMMENTS = 250
export const CHARACTER_LIMIT_COMMENTS_RAP = 240
